import SpotlightBadgeContainer from './SpotlightBadge.container';
import SpotlightBadge from './SpotlightBadge';
export default SpotlightBadgeContainer(SpotlightBadge);
